// TODO: Handle error on recommendation
import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  FormControlLabel,
  FormGroup,
  Switch,
  Grid,
  TextField,
  Typography,
  Slider,
  Tooltip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert,
  Autocomplete,
  Paper,
  Pagination,
  Container,
} from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ProvideRecommendation, { GetInBank, ProvideBankRecommendation,GetRecoEnableByPlant } from "../../utils/GetEquipmentInfoAll";
import VendingVisualizer, { prepColumns } from "../VendingVisualizer";
import CardKPI from "./CardKPIReco";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import MaterialsComponent from "../MaterialComponent";
import GetAML, { GetAllMaterialText } from "../../utils/GetAML";
import { useParams } from "react-router-dom";
import ResponsiveDrawer from "../../components/ClippedResponsiveDrawer";
import { createRequest, saveRequest, approveRequest } from "../../utils/PostRequest";
import CircularLoadButton, { LoadingStatus } from "../LoadingButton";
import GetVPSettlement from "../../utils/GetSettlement";
import VPSettlement from "../VPSettlement";
import VolumePrediction from "./VolumePredictionGraph";
import { checkForRole } from "../../utils/GetAuth";
import RequestTiny from "./RequestTiny";
import { getRequest, getRequests } from "../../utils/GetRequest";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import VendPrimeRequest from "../../pages/VendPrime/VendPrimeRequest";
import PageInPage from "../../componentUtils/PageInPage";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import requestMissingContexts, { determineConfig } from "../../utils/GetContext";
import { removeLeadingZeros } from "../../utils/Formatter";
import SettlementUnit from "../SettlementUnit";
import BankOverview from "../BankOverview";
import CardLocalFavorites from "../../components/CardLocalFavorites";
import CardTradeChannelView from "../../components/CardTradeChannelView";
import { GetCustomerRaw, GetSettlementInfoSpecific } from "../../utils/GetCustomer";
import { Bin } from "../../../../dist/utils/reco/bin";
import { Material, MaterialGridItem } from "../../../../dist/utils/reco/material";
import { AXIOS_INSTANCE, BASE_URL } from "src/App";
import EFRHistory from "../EFRHistory";
import GetEquipmentInfoSpecific, {
  CustomerEquipments,
} from "../../utils/GetEquipmentInfo";
import ReportProblemTwoToneIcon from '@mui/icons-material/ReportProblemTwoTone';
import CriticalFailure from "src/pages/CriticalFailure";
import { createFilterOptions } from "@mui/material/Autocomplete";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      overflowX: "hidden",
    },
    centerTitle: {
      textAlign: "center",
      padding: theme.spacing(1),
    },
    alert: {
      width: "100%",
      "& > * + *": {
        marginTop: theme.spacing(2),
      },
    },
    cardColor: {
      margin: 0,
      padding: 0,
    },
    slider: {
      width: `calc(100% - ${theme.spacing(3)})`,
    },
    buttongroup: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
      float: "right",
    },
    buttonAllGroup: {
      marginBottom: theme.spacing(2),
    },
    firstButtonGroup: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(2),
    },
    marginBottom: {
      marginBottom: theme.spacing(1),
    },
    buttonMargin: {
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    gridSpaceable: {
      paddingRight: theme.spacing(1),
    },
    heightMod: {
      height: "100%",
    },
    gridMarginTop: {
      [theme.breakpoints.down("lg")]: {
        margin: 0,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
      },
      [theme.breakpoints.up("xl")]: {
        margin: 0,
        paddingBottom: theme.spacing(1),
      },
    },
    subroot: {
      paddingTop: theme.spacing(4),
    },
    cardContent: {
      margin: 0,
      padding: theme.spacing(2),
    },
    undo: {
      width: 18,
      height: 18,
      marginTop: theme.spacing(1),
    },
    settlementGrid: {
      padding: theme.spacing(1),
      paddingTop: theme.spacing(4),
    },
    strategicChip: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    slightButtonPadding: {
      marginLeft: theme.spacing(1),
    },
    calloutsMarginTop: {
      marginTop: 4,
    },
    topFormGroup: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
    },
    vendingVisualizer: {
      marginLeft: theme.spacing(1),
    },
    progressHolder: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100vw",
      height: "100vh",
      textAlign: "center",
      backgroundColor: theme.palette.background.paper,
    },
    progressHolderTop: {
      padding: theme.spacing(2),
      margin: theme.spacing(2),
      borderColor: theme.palette.border.main,
      borderWidth: "2px",
      borderStyle: "solid",
      backgroundColor: theme.palette.background.default,
    },
    loadingTypography: {
      textAlign: "center",
      color: theme.palette.text.primary,
      paddingBottom: theme.spacing(2),
    },
    graphExtraPadding: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    marginAbove: {
      marginTop: theme.spacing(2),
    },
  })
);

interface ParameterInput {
  customer: string;
  identifier: string;
}

interface ParameterProp {
  fullpage?: boolean;
  customer?: string;
  identifier?: string;
  requestNum?: number;
}

function ThinkingLogo() {
  //const [darkMode] = useLocalStorage("SETTINGS.darkmode", false);
  const theme = useTheme();
  const fill = theme.palette.action.selected;
  const stroke = theme.palette.text.primary;
  const weight = 2;

  return (
    <svg
      version="1.0"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="84.047px"
      height="100px"
      viewBox="-3 -3 90.047 106"
      enable-background="new 0 0 84.047 100"
    >
      <path
        strokeWidth={weight}
        stroke={stroke}
        fill={fill}
        d="M58.224,24.481c-2.201,0-3.994,1.787-3.994,4.006c0,2.215,1.793,4.001,3.994,4.001c2.208,0,3.994-1.786,3.994-4.001
          C62.218,26.268,60.432,24.481,58.224,24.481z"
      />
      <path
        strokeWidth={weight}
        stroke={stroke}
        fill={fill}
        d="M57.285,57.296c0,2.215,1.8,4.005,4.012,4.005c2.201,0,3.987-1.79,3.987-4.005c0-2.213-1.786-4.003-3.987-4.003
          C59.084,53.293,57.285,55.083,57.285,57.296z"
      />
      <path
        strokeWidth={weight}
        stroke={stroke}
        fill={fill}
        d="M28.045,20.137c-2.215,0-4.008,1.794-4.008,4.012c0,2.212,1.793,4.002,4.008,4.002c2.219,0,4.009-1.791,4.009-4.002
          C32.054,21.931,30.264,20.137,28.045,20.137z"
      />
      <path
        strokeWidth={weight}
        stroke={stroke}
        fill={fill}
        d="M46.116,0C28.899,0,13.021,12.924,9.721,27.167c-0.747,3.166-1.565,11.435-1.565,11.435L0.228,58.564
          C0.076,58.923,0,59.328,0,59.753c0,1.683,1.379,3.058,3.069,3.058h5.087v10.605c0,8.27,6.7,14.968,14.959,14.968h5.946V100h40.486
          V67.794c8.83-6.946,14.5-17.736,14.5-29.842C84.047,16.989,67.06,0,46.116,0z M17.475,46.167c-2.321,0-4.219-1.897-4.219-4.244
          c0-2.333,1.897-4.227,4.219-4.227c2.343,0,4.25,1.894,4.25,4.227C21.725,44.271,19.818,46.167,17.475,46.167z M73.47,40.434
          l-3.946,3.947l-4.813-3.398c-0.927,0.484-1.901,0.868-2.917,1.127l-0.888,5.236h1.838l0.491,2.799
          c0.193,0.052,0.387,0.08,0.577,0.149c0.494,0.183,0.95,0.418,1.375,0.688l2.219-1.559l1.82,1.818l-1.634,2.319
          c0.353,0.622,0.629,1.285,0.784,1.986l2.678,0.46v2.575l-2.788,0.48c-0.056,0.196-0.083,0.394-0.152,0.587
          c-0.183,0.498-0.421,0.958-0.697,1.39l1.567,2.208l-1.823,1.821l-2.306-1.638c-0.625,0.353-1.285,0.629-1.99,0.784l-0.47,2.682
          h-2.574l-0.464-2.799c-0.2-0.056-0.4-0.083-0.598-0.156c-0.494-0.183-0.953-0.418-1.382-0.69l-2.222,1.575l-1.811-1.824l1.638-2.315
          c-0.353-0.626-0.629-1.285-0.784-1.99l-2.692-0.467v-2.564l2.813-0.48c0.055-0.197,0.083-0.395,0.155-0.591
          c0.18-0.491,0.414-0.947,0.684-1.376l-1.568-2.222l1.817-1.818l2.319,1.638c0.621-0.349,1.281-0.625,1.982-0.784l0.401-2.326h-4.848
          l-1.013-5.807c-0.218-0.069-0.436-0.125-0.653-0.208c-0.781-0.287-1.507-0.646-2.201-1.05l-4.645,3.273l-3.939-3.951l3.39-4.797
          c-0.487-0.929-0.871-1.907-1.133-2.927l-5.585-0.961v-4.586l-2.812,0.485c-0.045,0.135-0.056,0.273-0.107,0.404
          c-0.184,0.498-0.422,0.954-0.681,1.396l2.156,3.055l-2.596,2.588l-3.165-2.232c-0.588,0.304-1.195,0.553-1.835,0.722l-0.64,3.663
          l-3.645,0.003l-0.664-3.822c-0.128-0.045-0.263-0.055-0.391-0.104c-0.501-0.187-0.964-0.429-1.409-0.691l-3.065,2.16l-2.585-2.592
          l2.242-3.176c-0.297-0.581-0.528-1.192-0.697-1.822l-3.688-0.632v-3.667l3.801-0.653c0.042-0.135,0.073-0.266,0.121-0.397
          c0.184-0.501,0.426-0.96,0.685-1.403l-2.16-3.055l2.582-2.589l3.179,2.236c0.588-0.305,1.199-0.557,1.842-0.727l0.639-3.666h3.646
          L30.9,16c0.132,0.042,0.267,0.052,0.394,0.1c0.502,0.187,0.961,0.43,1.407,0.688l3.055-2.153l2.595,2.589l-2.246,3.172
          c0.305,0.584,0.553,1.192,0.719,1.832l3.663,0.629v2.665l4.797-0.823c0.069-0.218,0.124-0.435,0.207-0.653
          c0.287-0.785,0.65-1.521,1.062-2.219L43.257,17.2l3.964-3.955l4.807,3.398c0.93-0.485,1.908-0.868,2.928-1.131l0.943-5.588h5.587
          l1.013,5.802c0.218,0.065,0.436,0.125,0.653,0.204c0.777,0.287,1.507,0.65,2.197,1.055l4.647-3.273l3.933,3.947l-3.39,4.814
          c0.48,0.922,0.863,1.897,1.126,2.91l5.596,0.964v5.589l-5.806,0.999c-0.069,0.218-0.125,0.436-0.204,0.65
          c-0.29,0.781-0.653,1.51-1.062,2.205L73.47,40.434z"
      />
    </svg>
  );
}



const filter = createFilterOptions({
  stringify: (option:any) => `${option.data} ${option.material_num} ${option.source}`,
  // DO NOT de-duplicate
});

export default function RecommendationComponent(props: ParameterProp) {
  const [showCritFail, setShowCritFail] = React.useState<boolean>(false);   
  const classes = useStyles();
  const [state, setState] = useState<any>({
    replaced: [],
    toReplace: [],
    replacing: [],
    replacePtr: 0,
    applyRecommendation: true,
    useBrandflowOpt: false,
    displayBankOverview: false,
    displayEFRHistory: false,
    sortOrder: null,
    bankedRecos: [],
    bankedReplaced: [],
    bankedApplyRecommendation: [],
  });
  const [displayPip, setDisplayPip] = useState<boolean>(false);
  const [displayInvoicePip, setDisplayInvoicePip] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [showCurrent, setShowCurrent] = useState<boolean>(true);
  const [newFlavors, setNewFlavors] = useState<boolean>(true);
  const [maxFlavors, setMaxFlavors] = useState<boolean>(false);
  const [requestNum, setRequestNum] = useState<number>(0);
  const [requestStatus, setRequestStatus] = useState<String>("UNSAVED");
  const [confirmDialog, setConfirmDialog] = useState<boolean>(false);
  const [settlementData, setSettlementData] = useState<any>([]);
  const [EFRHistoryData, setEFRHistoryData] = useState<any>([]);
  const [dialogMessage, setDialogMessage] = useState<any>({
    code: 0,
    message: "",
  });
  const [reqStatus, setReqStatus] = useState<{ [key: string]: LoadingStatus }>({
    VP_AS_IS: LoadingStatus.Initial,
    VP_DRAFT: LoadingStatus.Initial,
    VP_QUEUE: LoadingStatus.Initial,
    VP_ACCEPT: LoadingStatus.Initial,
  });
  const [recoStatus, setRecoStatus] = useState<LoadingStatus>(LoadingStatus.Initial);
  const [initialPageLoad, setInitialPageLoad] = useState<boolean>(true);
  const [sliderValue, setSliderValue] = useState<number | number[]>([0, 0]);
  const [sumLines, setSumLines] = useState<any>([]);
  const [orderState, setOrderState] = useState<any>({
    name: "material_num",
    direction: "asc",
  });
  const [orderStateReco, setOrderStateReco] = useState<any>({
    name: "material_num",
    direction: "asc",
  });
  
  const [recAllowed, setRecAllowed] = useState<boolean>(false);
  const [isBankError, setIsBankError] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<String>("");
  const [isDefaultQuantity, setIsDefaultQuantity] = useState<boolean>(false);
  
  const [isMinFlavourLogic, setIsMinFlavourLogic] = useState<boolean>(false);
  const [minFlavourCount, setMinFlavourCount] = useState<String>("");
  const [isCurrMatNotAML, setIsCurrMatNotAML] = useState<boolean>(false);
  const [isCurrMatNotAMLMessage, SetIsCurrMatNotAMLMessage] = useState<String>("");

  

  let params = useParams<ParameterInput>();
  let customer = props.customer || params.customer;

  useEffect(() => {
    GetEquipmentInfoSpecific(salesOrg.toString(), customer, true).then(
      (v: CustomerEquipments[]) => {
        if(v?.length > 0 && (v[0]?.status === 'INIT' || v[0]?.status === 'DISP'||(v[0]?.activity&&v[0]?.activity === 'INIT') || (v[0]?.activity&&v[0]?.activity === 'DISP')
        ||(v[0]?.vps_activity&&v[0]?.vps_activity === 'INIT') || (v[0]?.vps_activity&&v[0]?.vps_activity === 'DISP'))){
          setRecAllowed(true)
        }else{
          setRecAllowed(false)
        }
      })
  }, []);
  const [custState, setCustState] = useState<string>(customer);

  const [btnActive, setBtnActive] = useState<boolean>(false);

  document.title = `Reconfiguration: ${customer}`;

  const SettlementWrapper = () => (
    <VPSettlement customerNum={custState} salesOrg={salesOrg} data={state.settlementsUntouched} hideAccordion={true} />
  );
  const VolumePredictions = () => (
    <div style={{ height: "500px" }}>
      <VolumePrediction dataI={state.data} swapElement={highlightClick} toReplace={state.toReplace} />
    </div>
  );

  const useOnHover = (matnr: string) => {
    let isSubmitting = false;

    for (let i in reqStatus) {
      if (reqStatus[i] === LoadingStatus.Loading) {
        isSubmitting = true;
        break;
      }
    }

    if (!state.editCapacity && !isSubmitting) setSelected(matnr);
  };
  const Visualizers = () => (
    <Grid container className={classes.gridMarginTop} spacing={1}>
      <Grid item sm={12} xl={6}>
        {showCurrent && (
          <Card className={classes.heightMod} elevation={4}>
            <CardContent className={classes.cardContent}>
              <VendingVisualizer
                recommended={[]}
                onHover={useOnHover}
                replacing={[]}
                selected={selected}
                replaced={[]}
                replacePtr={0}
                cols={state.data.cols}
                materials={state.data.curr}
                columns={state.data.cmap}
                columnmap={state.data.columns}
                salesOrg={salesOrg}
              />
            </CardContent>
          </Card>
        )}
      </Grid>
      <Grid item sm={12} className={classes.gridMarginTop} xl={!showCurrent ? 12 : 6} key="VendVizReco-grid">
        <Card elevation={4} key="VendVizReco-card">
          <CardContent className={classes.cardColor} key="VendVizReco-CardCont">
            <VendingVisualizer
              key="VendVizReco"
              editCapacity={state.editCapacity}
              onEditCapacity={changeCapacity}
              cols={state.data.cols}
              recommended={state.data.mapd}
              applyRecommended={state.applyRecommendation}
              onHover={useOnHover}
              salesOrg={salesOrg}
              onSwap={(from: MaterialGridItem, to: MaterialGridItem) => {
                let replTmp: MaterialGridItem[] = [];

                replTmp.push({
                  material: { ...from.material },
                  column_num: to.column_num,
                  modified: true,
                  swapped:true,
                });

                replTmp.push({
                  material: {
                    ...to.material,
                  },
                  column_num: from.column_num,
                  modified: true,
                  swapped:false,
                });

                onTheFlyMatMap({
                  ...state,
                  replaced: [...state.replaced, ...replTmp],
                  bankedReplaced: [
                    ...state.bankedReplaced,
                    ...replTmp.map((v) => ({
                      machine: custState,
                      data: v,
                    })),
                  ],
                });
              }}
              onSelect={(curr: any) => {
                let found = false;
                let toRepl = state.toReplace.filter((v: any) => {
                  found = v.column_num === curr.column_num;
                  return v.column_num !== curr.column_num;
                });

                if (!found) toRepl.push(curr);

                setState({
                  ...state,
                  toReplace: [...toRepl],
                });
              }}
              onInsert={(from, to, direction) => {
                let columns: string[] = Object.values(state.data.cols.columns);
                let toRepl = [];
                let prepped = prepColumns({
                  cols: state.data.cols,
                  applyRecommended: state.applyRecommendation,
                  recommended: state.data.mapd,
                  replacing: state.toReplace,
                  selected: selected,
                  replaced: state.replaced,
                  replacePtr: state.replacePtr,
                  materials: state.data.reco.materials,
                  columns: state.data.mapd,
                  columnmap: state.data.columns,
                });

                if (from.column_num.localeCompare(to.column_num) === 0) return;

                if (state.toReplace.length > 0) {
                  /**
                   * Insert multiple. First grab column map and
                   * sort the materials by their column.
                   */
                  let cols = Object.values(state.data.cols.columns);
                  let sortedToReplace = state.toReplace.sort((a: any, b: any) => {
                    return cols.indexOf(a.column_num) - cols.indexOf(b.column_num);
                  });

                  /**
                   * Check if we are moving them backwards (towards the top-left
                   * of the machine). If we are, we need to handle this
                   * situation differently.
                   */
                  let movingBackwards = cols.indexOf(to.column_num) < cols.indexOf(from.column_num);

                  /**
                   * Find the index of the drop point.
                   */
                  let indexOfDropPoint = columns.indexOf(to.column_num) - (movingBackwards ? 0 : 1);

                  /**
                   * Remove the columns (essentially lift them) that we are moving.
                   */

                  for (let _replaceable of sortedToReplace) {
                    for (let _prep of prepped) {
                      if (_prep.column_num === _replaceable.column_num) {
                        prepped.splice(prepped.indexOf(_prep), 1);
                        break;
                      }
                    }
                  }

                  /**
                   * Put all the others in the replace map.
                   */
                  for (let _prep of prepped) {
                    toRepl.push({
                      material: { ..._prep.material },
                      column_num: _prep.column_num,
                    });
                  }

                  /**
                   *
                   */
                  for (let current of toRepl) {
                    let done = false;
                    let idxOfCurr = columns.indexOf(current.column_num);

                    if (idxOfCurr >= indexOfDropPoint) {
                      for (let toInsert of sortedToReplace) {
                        let dirVal = direction === "Right" ? 1 : -1;
                        let idx = indexOfDropPoint + dirVal;
                        let idxOfNewCol = columns[idx];

                        toRepl.splice(indexOfDropPoint++, 0, {
                          material: { ...toInsert.material },
                          column_num: idxOfNewCol,
                        });

                        done = true;
                      }

                      if (done) break;
                    }
                  }

                  /**
                   * Finalize by fixing up the column numbers.
                   */
                  let ptrToCol = 0;
                  for (let newCol of toRepl) {
                    newCol.column_num = columns[ptrToCol++];
                  }

                  onTheFlyMatMap({
                    ...state,
                    toReplace: [],
                    replaced: [...state.replaced, ...toRepl],
                  });
                } else {
                  /**
                   * Insert one.
                   */

                  let indexOfFrom = columns.indexOf(from.column_num);
                  let indexOfTo = columns.indexOf(to.column_num);
                  let movingForward = indexOfFrom < indexOfTo;
                  let newStartingCol = columns[indexOfTo];
                  let columnsToPickupAndMove: string[] = [];

                  toRepl.push({
                    material: {
                      ...from.material,
                    },
                    ugh: true,
                    column_num: newStartingCol,
                  });

                  if (movingForward) {
                    for (let i = indexOfFrom; i <= indexOfTo; i++) {
                      columnsToPickupAndMove.push(columns[i]);
                    }
                  } else {
                    for (let i = indexOfFrom - 1; i >= indexOfTo; i--) {
                      columnsToPickupAndMove.push(columns[i]);
                    }
                  }
                  for (let col of columnsToPickupAndMove) {
                    let found = prepped.find((v: any) => v.column_num === col);

                    if (found) {
                      let indexOfCol = columns.indexOf(col) + (movingForward ? -1 : 1);
                      let colIndex = columns[indexOfCol];

                      toRepl.push({
                        material: {
                          ...found.material,
                        },
                        column_num: colIndex,
                      });
                    }
                  }

                  onTheFlyMatMap({
                    ...state,
                    toReplace: [],
                    replaced: [...state.replaced, ...toRepl],
                  });
                }
              }}
              onDragReplace={(to: MaterialGridItem, from: MaterialGridItem) => {
                let replTmp: MaterialGridItem[] = [];
                let v = {
                  material: {
                    ...from.material,
                  },
                  column_num: to.column_num,
                  modified: true,
                  swapped:false,
                };

                replTmp.push(v);

                onTheFlyMatMap({
                  ...state,
                  replaced: [...state.replaced, ...replTmp],
                  bankedReplaced: [
                    ...state.bankedReplaced,
                    {
                      machine: custState,
                      data: v,
                    },
                  ],
                });
              }}
              replacing={state.toReplace}
              selected={selected}
              replaced={state.replaced}
              replacePtr={state.replacePtr}
              materials={state.data.reco.materials}
              columns={state.data.cmap}
              columnmap={state.data.columns}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );

  const MaterialsComponents = () => (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={6}>
        <MaterialsComponent
          customer={custState}
          state={state}
          selected={selected}
          isActive={true}
          onHover={useOnHover}
          orderState={orderState}
          onOrderStateChange={(changedColumn: string, direction: string) => {
            setOrderState({
              name: changedColumn,
              direction: direction,
            });
          }}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MaterialsComponent
          customer={custState}
          state={state}
          selected={selected}
          onHover={useOnHover}
          isActive={false}
          orderState={orderStateReco}
          onOrderStateChange={(changedColumn: string, direction: string) => {
            setOrderStateReco({
              name: changedColumn,
              direction: direction,
            });
          }}
          showRecommendation={state.applyRecommendation}
          onPriceChange={(matnr, price) => {
            let toRepl: Material[] = [];
            let preppedColumns = prepColumns({
              cols: state.data.cols,
              applyRecommended: state.applyRecommendation,
              recommended: state.data.mapd,
              replacing: state.toReplace,
              selected: selected,
              replaced: state.replaced,
              replacePtr: state.replacePtr,
              materials: state.data.reco.materials,
              columns: state.data.cmap,
              columnmap: state.data.columns,
            });

            for (let mat of preppedColumns) {
              if (mat.material.material_num === matnr) {
                toRepl.push({
                  ...mat,
                  material: {
                    ...mat.material,
                    price,
                  },
                });
              }
            }

            onTheFlyMatMap({
              ...state,
              replaced: [...state.replaced, ...toRepl],
              bankedReplaced: [
                ...state.bankedReplaced,
                {
                  data: toRepl,
                  machine: custState,
                },
              ],
            });
          }}
        />
      </Grid>
    </Grid>
  );

  const prepSumMatLine = (force?: boolean) => {
    let matSumLines: any = [];

    if (sumLines.length > 0 && !force) return;
    if (!state.data.mapd) return;
    let prepFinalConfig = prepColumns({
      recommended: Object.values(state.data.mapd),
      cols: state.data.cols,
      applyRecommended: state.applyRecommendation,
      replacing: state.toReplace,
      selected: selected,
      replaced: state.replaced,
      replacePtr: state.replacePtr + 1,
      materials: state.data.curr,
      columns: state.data.curr,
    });

    let prepCurrentLayout = prepColumns({
      recommended: [],
      onHover: useOnHover,
      replacing: [],
      selected: selected,
      replaced: [],
      replacePtr: 0,
      cols: state.data.cols,
      materials: state.data.curr,
      columns: state.data.cmap,
      columnmap: state.data.columns,
    });

    let materialMapCurr: any = {};
    let materialMapFinal: any = {};

    prepCurrentLayout.forEach((pred: any) => {
      if (materialMapCurr[pred.material_num]) {
        materialMapCurr[pred.material_num] = {
          ...materialMapCurr[pred.material_num],
          columnCount: materialMapCurr[pred.material_num].columnCount + 1,
        };
      } else {
        materialMapCurr[pred.material_num] = {
          materialNum: pred.material_num,
          columnCount: 1,
          capacity: pred.max_fill,
          vendPrice: pred.vend_price || 0.0,
          stockoutDays: pred.days_cover,
          averageEaches: pred.avg_eaches,
        };
      }
    });

    prepFinalConfig.forEach((pred: any) => {
      if (materialMapFinal[pred.material_num]) {
        materialMapFinal[pred.material_num] = {
          ...materialMapFinal[pred.material_num],
          columnCount: materialMapFinal[pred.material_num].columnCount + 1,
        };
      } else {
        materialMapFinal[pred.material_num] = {
          materialNum: pred.material_num,
          columnCount: 1,
          capacity: pred.max_fill,
          vendPrice: parseFloat(pred.vend_price) || 0.0,
          stockoutDays: pred.days_cover,
          averageEaches: pred.avg_eaches,
        };
      }
    });

    let seen: any = {};

    for (let final in materialMapFinal) {
      let finalMat = materialMapFinal[final];
      for (let old in materialMapCurr) {
        let oldMat = materialMapCurr[old];

        if (oldMat.materialNum === finalMat.materialNum) {
          let oldSoDays = (oldMat.columnCount * oldMat.capacity) / (oldMat.averageEaches || 1.0);
          let newSoDays = (finalMat.columnCount * finalMat.capacity) / (finalMat.averageEaches || 1.0);

          matSumLines.push({
            materialNum: finalMat.materialNum,
            change: {
              action: "EDIT",
              capacity: Math.abs(finalMat.capacity - oldMat.capacity),
              columnCount: Math.abs(finalMat.columnCount - oldMat.columnCount),
              stockoutDays: Math.abs(newSoDays - oldSoDays),
              vendPrice: Math.abs(finalMat.vendPrice - oldMat.vendPrice),
            },
            R: {
              capacity: finalMat.capacity * finalMat.columnCount,
              columnCount: finalMat.columnCount,
              stockoutDays: newSoDays.toFixed(2),
              vendPrice: finalMat.vendPrice,
            },
            C: {
              capacity: oldMat.capacity * oldMat.columnCount,
              columnCount: oldMat.columnCount,
              stockoutDays: oldSoDays.toFixed(2),
              vendPrice: oldMat.vendPrice,
            },
          });
          seen[finalMat.materialNum] = true;
          break;
        }
      }
    }

    for (let final in materialMapFinal) {
      let finalMat = materialMapFinal[final];
      if (!seen[finalMat.materialNum]) {
        seen[finalMat.materialNum] = true;
        let newSoDays = (finalMat.columnCount * finalMat.capacity) / finalMat.averageEaches;

        matSumLines.push({
          materialNum: finalMat.materialNum,
          change: {
            action: "ADD",
            capacity: finalMat.capacity,
            columnCount: finalMat.columnCount,
            stockoutDays: newSoDays.toFixed(2),
            vendPrice: finalMat.vendPrice,
          },
          R: {
            capacity: finalMat.capacity * finalMat.columnCount,
            columnCount: finalMat.columnCount,
            stockoutDays: newSoDays.toFixed(2),
            vendPrice: finalMat.vendPrice,
          },
        });
      }
    }

    for (let curr in materialMapCurr) {
      let currMat = materialMapCurr[curr];
      if (!seen[currMat.materialNum]) {
        let newSoDays = (currMat.columnCount * currMat.capacity) / currMat.averageEaches;
        seen[currMat.materialNum] = true;
        matSumLines.push({
          materialNum: currMat.materialNum,
          change: {
            action: "REMOVE",
            capacity: currMat.capacity,
            columnCount: currMat.columnCount,
            stockoutDays: newSoDays.toFixed(2),
            vendPrice: currMat.vendPrice,
          },
          C: {
            capacity: currMat.capacity * currMat.columnCount,
            columnCount: currMat.columnCount,
            stockoutDays: newSoDays.toFixed(2),
            vendPrice: currMat.vendPrice,
          },
        });
      }
    }

    setSumLines(matSumLines);
  };

  const getRequestObjects = (req: any) => {
    if (req && req.requests) {
      let now = new Date();
      const filterOutOldReq = (r: any) => {
        if([ "I", // inprogress 5
          "M"// mobile
          ].findIndex((s) => s === r.requestStatus) >= 0){
            return true;
        } else if (
          [
            "VP_AS_IS", //no change 10
            "Y",// pari
            "S",// sucess
            "VP_DRAFT",// draft
            "VP_QUEUE", // queue
            "VP_REQUST", // 
            "VP_ACCEPT", // accept
            "VP_SUBMIT",         
            "O", //open
          ].findIndex((s) => s === r.requestStatus) >= 0
        ) {
          //console.log("time details ",r.ticketpollopenDetails,r.requestStatus,r.requestedDt,Date.parse(r.requestedDt),new Date(Date.parse(r.requestedDt)));
          let days_back = Math.ceil(
            Math.abs(new Date(Date.parse(r.requestedDt)).getTime() - now.getTime()) / (1000 * 3600 * 24)
          );
          if(r.requestStatus === "I" || r.requestStatus === "M"){
            if (days_back <= 60) {return true;}
          }
          else if(r.requestStatus === "O"|| r.requestStatus === "VP_ACCEPT" || r.requestStatus === "VP_SUBMIT" || r.requestStatus === "VP_QUEUE"  ||  r.requestStatus === "VP_AS_IS" ||  r.requestStatus === "C"){
            if (days_back <= Number(r.ticketpollopenDetails)) {return true;}
            }
          else if(r.requestStatus === "VP_DRAFT")  {
          
            if (days_back <= 30) {return true;}
          }
            else{
              if (days_back <= Number(r.ticketpollCompleteDetails)) {return true;}
            }

        }
        // else{
        //   console.log("time details",r.requestStatus,r.requestedDt,Date.parse(r.requestedDt),new Date(Date.parse(r.requestedDt)));
        // }
        // else ([
        //   "VP_AS_IS", //no change 
        //   "Y",// pari
        //   "S",// sucess
        //   "M",// mobile
        //   "VP_DRAFT",// draft
        //   "VP_QUEUE", // queue
        //   "VP_REQUST", // 
        //   "VP_ACCEPT", // accept
        //   "VP_SUBMIT", ].findIndex((s) => s === r.requestStatus) >= 0){
        //     console.log("time details",r.requestStatus,r.requestedDt,Date.parse(r.requestedDt),new Date(Date.parse(r.requestedDt)));
        //     let days_back = Math.ceil(
        //       Math.abs(new Date(Date.parse(r.requestedDt)).getTime() - now.getTime()) / (1000 * 3600 * 24)
        //     );
  
        //     if (days_back <= 30) return true;
        // }

        return false;
      };

      return req.requests.filter((r: any) => filterOutOldReq(r));
    }
    return [];
  };

  useEffect(() => {
    if (state.data && state.data.errorMessage) return;
    if (state.isLoaded && !state.nextCustomer) return;    
    const getRequestNumbers = async () => {
      return await getRequests(salesOrg, {
        customerNum: custState,
      }).catch((err: any) => null);
    };

    if (state.nextCustomer) {
      const applyBankReco = state.bankedApplyRecommendation.find((v: any) => v.machine === custState);
      getRequestNumbers().then((e) => {
        const res = getRequestObjects(e);
        setRequestNum(res.length > 0 ? res[0]?.requestNum : 0);
        setRequestStatus(res.length > 0 ? res[0]?.requestStatus : "UNSAVED");
        setReqStatus({
          VP_AS_IS: LoadingStatus.Initial,
          VP_DRAFT: LoadingStatus.Initial,
          VP_QUEUE: LoadingStatus.Initial,
          VP_ACCEPT: LoadingStatus.Initial,
        });
      });

      return setState({
        ...state,
        nextCustomer: false,
        applyRecommendation: applyBankReco ? applyBankReco.state : true,
        data: {
          ...state.bankedRecos.find((v: any) => {
            if(v.info){
              return v.info.customer_num === custState
            }
          }),
        },
      });
    }
    const getCodes = async () => {
      return await requestMissingContexts(["GRAPHICS"]);
    };

    const grabSettlements = () => {
      if (!sliderValue || !state.dateSorted) return { data: [null, null], count: 6 };
      return {
        data: (sliderValue as any[]).map((v: any) => state.dateSorted[v]),
        count: (((sliderValue as any)[1] - (sliderValue as any)[0]) as any) + 1 || 6,
      };
    };
    const queryData = async () => {
      let info = await GetCustomerRaw(salesOrg, custState);
      let req = await getRequestNumbers();
      req.requests = getRequestObjects(req);
      let eqinf: any = {};
      let bankedRecos: any[] = [];

      if (props.requestNum || (req && req.requests && req.requests.length >= 1)) {
        const chosenRequest = await getRequest(salesOrg, props.requestNum || req.requests[0].requestNum);
        const layouts = chosenRequest.request.txReqReconfigCol;
        const current = layouts.filter((v: any) => v.configType === "C");
        const reco = layouts.filter((v: any) => v.configType === "R");
        setRequestNum(chosenRequest.request.requestNum);
        setRequestStatus(chosenRequest.request.requestStatus);
        const columnMap: { [key: string]: string } = {};

        const columnsMap = chosenRequest.col_map;
        columnsMap.forEach((group: any) => {
            group.forEach((column: any) => {
                columnMap[column.columnNum] = column.columnLabel;
            });
        });
       
        let fn = (v: any, parent: any) => {
          v = {
            material: {
              ...v,
              material_num: v.materialNum,
              eaches: v.avgEaches,
              capacity: v.columnCapacity,
              price: v.vendPrice,
            },
            column_Num: v.columnNum,
            column_num:columnMap[v.columnNum] || v.columnNum
          };

          return v;
        };
       
        const cmap:any = current.map((v: any) => fn(v, current)).sort((a:any, b:any) => {
          if( chosenRequest.request.glass_front){
            return parseInt(a.column_Num) > parseInt(b.column_Num) ? 1 : -1;
          } else{
            return parseInt(b.column_Num) > parseInt(a.column_Num) ? 1 : -1;
          }
        });
        const mapd = reco.map((v: any) => fn(v, reco)).sort((a:any, b:any) => {
          if( chosenRequest.request.glass_front){
            return parseInt(a.column_Num) > parseInt(b.column_Num) ? 1 : -1;
          } else{
            return parseInt(b.column_Num) > parseInt(a.column_Num) ? 1 : -1;
          }
        });
        let rmats: any[] = [];
        for (let i of mapd) {
          let mat = rmats.find((v: any) => v.material.material_num === i.material.material_num);

          if (!mat) rmats.push(i);
        }
        const rmapd = {
          materials: rmats,
        };
        eqinf = {
          loaded: true,
          info,
          cmap,
          mapd,
          reco: rmapd,
          cols: {
            items_per_row: chosenRequest.col_map[0].length,
          },
          local: [],
          columns: chosenRequest.col_map,
          kpis: [
            {
              days_cover: chosenRequest.request.txReqReconfigKpi.find((item:any) => item.name === "Days until Stockout").predictedValue,
              eaches: chosenRequest.request.txReqReconfigKpi.find((item:any) => item.name === "Vends/Day").predictedValue,
              source: "Recommended",
              efr: chosenRequest.request.txReqReconfigKpi.find((item:any) => item.name === "Eff. Fill Rate").predictedValue,
              grlc: chosenRequest.request.txReqReconfigKpi.find((item:any) => item.name === "GRLC/Day").predictedValue,
              rev: chosenRequest.request.txReqReconfigKpi.find((item:any) => item.name === "Revenue/Day").predictedValue
            },
            {
              avg:(chosenRequest.request.txReqReconfigKpi.find((item:any) => item.name === "Avg. Visit Period")|| { currentValue: 0 }).currentValue,
              days_cover: chosenRequest.request.txReqReconfigKpi.find((item:any) => item.name === "Days until Stockout").currentValue,
              eaches: chosenRequest.request.txReqReconfigKpi.find((item:any) => item.name === "Vends/Day").currentValue,
              source: "Current",
              efr: chosenRequest.request.txReqReconfigKpi.find((item:any) => item.name === "Eff. Fill Rate").currentValue,
              grlc: chosenRequest.request.txReqReconfigKpi.find((item:any) => item.name === "GRLC/Day").currentValue,
              rev: chosenRequest.request.txReqReconfigKpi.find((item:any) => item.name === "Revenue/Day").currentValue
            },
          ],
        };
      }
      let [tmpAml, settlementsUntouched, texts, codes] = await Promise.all([
        GetAML(salesOrg, custState).catch((err) => {console.error('Error while trying to get GetAML Response from the server'); setShowCritFail(true);}),
        GetVPSettlement(salesOrg, custState).catch((err) => {console.error('Error while trying to get GetVPSettlement response from the server'); setShowCritFail(true);}),
        GetAllMaterialText().catch((err) => {console.error('Error while trying to get GetAllMaterialText response from the server'); setShowCritFail(true);}),
        getCodes(),
      ]);

      let loadedRequest = false;
      if (Object.keys(eqinf).length === 0) {
        eqinf.bankInfo = await GetInBank(salesOrg, custState);
        const isRecoEnableByPlant = await GetRecoEnableByPlant(salesOrg);
       let recoByPlant = false;
        if(isRecoEnableByPlant.length>0){
          recoByPlant = true;
        }
        if (eqinf.bankInfo && eqinf.bankInfo.length >= 2) {
          bankedRecos = await ProvideBankRecommendation(salesOrg, custState, maxFlavors,info.sales_office,recoByPlant);
     
          if (bankedRecos.length === 0) {
            setShowCritFail(true);
          }

          const customerNumsWithError = bankedRecos.filter(item => item.errorMessage)  // Filter items with errorMessage
                                        .map(item => item.customer_num);    // Extract customer_num from those items
 
          if(customerNumsWithError.length>0){
            const csv = customerNumsWithError.join(',');
            setIsBankError(true);
            setErrorMsg(`Banked Customer ${csv} has errors`);
          }
          
          eqinf = bankedRecos.find((v) => 
            v.info ?  v.info.customer_num === custState : v.customer_num === custState 
           );
        } else {
          eqinf = await ProvideRecommendation(
            salesOrg.toString(),
            custState,
            newFlavors,
            maxFlavors,
            state.useBrandflowOpt,
            true,
            grabSettlements().data,
            grabSettlements().count,
            info.sales_office,
            recoByPlant
          );
          if (Object.keys(eqinf).length === 0) {
            setShowCritFail(true);
          }
        }

        loadedRequest = true;
      } else {
        /**
         * Perform description mapping since Michael's API does not return
         * that information for a request.
         */
        for (let i of eqinf.mapd) {
          for (let textLong of texts.materialTxt) {
            if (i.material.material_num === textLong.materialNum) {
              i.material.description = textLong.description;
              break;
            }
          }
        }

        for (let i of eqinf.cmap) {
          for (let textLong of texts.materialTxt) {
            if (i.material.material_num === textLong.materialNum) {
              i.material.description = textLong.description;
              break;
            }
          }
        }
      }

      let aml = tmpAml.aml;
      let strategic = tmpAml.strategic;

      let tmpSettlements: any = {};
      let dateSorted: any = [];

      const local = eqinf?.local;

      settlementsUntouched.forEach((x: any) => (tmpSettlements[x.visit_dt] = true));

      Object.keys(tmpSettlements).map((v: string) => dateSorted.push(v));

      dateSorted = dateSorted.sort((a: string, b: string) => Date.parse(a) - Date.parse(b));

      let settlements: any = {};

      Object.entries(tmpSettlements)
        .map((v: any) => {
          settlements[Date.parse(v)] = true;
          return Date.parse(v);
        })
        .sort((a: any, b: any) => a - b);

      return {
        req,
        eqinf,
        aml,
        dateSorted: dateSorted,
        settlements: tmpSettlements,
        settlementsUntouched,
        strategic,
        local,
        texts,
        codes,
        loadedRequest,
        bankedRecos,
      };
    };
  
    queryData()
      .then((res: any) => {
        if(res.eqinf==undefined){
          setState({data: {errorMessage: "Failed to generate Recommendation. Please open an incident in CONA Service Now if issue continues"}})
        }else if(res.eqinf?.errorMessage){
          return setState({
            data: {
              errorMessage: res.eqinf.errorMessage,
            }
          })
        }
        if(res.eqinf.applyEachesCheck && (res.eqinf.reco.length<1)){
            setIsMinFlavourLogic(true); setMinFlavourCount(res.eqinf.curr[0].min_flavors);
        }
        const invalidAmlMaterialNums = res.eqinf.curr.filter((item:any) => item.aml_valid_flag === 0).map((item:any) => item.material_num.replace(/^0+/, ''));
        if(invalidAmlMaterialNums && invalidAmlMaterialNums.length>0){
          setIsCurrMatNotAML(true); 
          SetIsCurrMatNotAMLMessage(`Material(s) ${invalidAmlMaterialNums.join(',')} is/are not included in the AML assigned to the customer.`);
        }
        setTimeout(() => setRecoStatus(LoadingStatus.Initial), initialPageLoad ? 0 : 250);

        onTheFlyMatMap({
          ...state,
          data: res.eqinf,
          aml: res.aml.materials,
          isLoaded: true,
          dateSorted: res.dateSorted,
          settlements: res.settlements,
          settlementsUntouched: res.settlementsUntouched,
          strategic: res.strategic,
          local: res.local,
          req: res.req,
          texts: res.texts,
          codes: res.codes,
          bankedRecos: res.bankedRecos || [],
        });

        setRecoStatus(LoadingStatus.Success);

        let settlementCount = Object.keys(res.settlements).length;

        let outputSettlementStart = 0;
        let outputSettlementEnd = settlementCount;
        if (settlementCount < 6) {
          outputSettlementEnd = settlementCount;
          outputSettlementStart = 0;
        } else if (settlementCount > 6) {
          outputSettlementEnd = settlementCount;
          outputSettlementStart = settlementCount - 6;
        }

        if (initialPageLoad) setSliderValue([outputSettlementStart, outputSettlementEnd - 1]);

        setInitialPageLoad(false);
      })
      .catch((err) => console.error(err));
  }, [custState, state, reqStatus]);

  useEffect(() => {
    GetSettlementInfoSpecific(salesOrg.toString(), custState).then((v: any) => {
      setSettlementData(v.settlement);
    });

    const efr: any =
      state.settlementsUntouched?.filter(
        (v: any, i: any, a: any) =>
          a.findIndex((v2: any) => v2.visit_dt === v.visit_dt && v2.request_num === v.request_num) === i
      ) || [];

    var uniqueEfr: any =
      efr?.filter((v: any, i: any, a: any) => a.findIndex((v2: any) => v2.order_num === v.order_num) === i) || [];

    const dataObject: any[] =
      efr?.filter(
        (v: any, i: any, a: any) =>
          a.findIndex(
            (v2: any) => v2.ticket_num === v.sap_request_number && v2.request_num === v.request_num && v2.ticket_num
          ) === i
      ) || [];

    var flagTicket = "";

    if (dataObject.length > 0) {
      [...dataObject].forEach((o: any, i: any) => {
        uniqueEfr.map((e: any) => {
          if (!e.ticket_num) {
            e.sap_request_number = "";
            e.request_num = "";
            e.predicted_value_rate = "";
          }
          if (flagTicket) {
            e.predicted_value_rate = flagTicket;
          }
          if (e.visit_dt === o.visit_dt && e.ticket_num && e.ticket_num === o.ticket_num) {
            e.predicted_value_rate = o.predicted_value ? o.predicted_value : 0;
            e.request_num = o.request_num;
            e.diff_from_prediction = e.predicted_value_rate - e.fillRate;
            e.sap_request_number = o.sap_request_number;
          }
          if (e.ticket_num) {
            flagTicket = e.predicted_value_rate;
          }
        });
      });
      setEFRHistoryData(uniqueEfr);
    } else {
      uniqueEfr.map((e: any) => {
        e.predicted_value_rate = "";
        e.diff_from_prediction = "";
      });
      setEFRHistoryData([]);
    }
  }, [salesOrg, state.settlementsUntouched]);


  // if (state && state.data && state.data.optimizationFailed) return <div>{state.data.optimizationFailureReason}</div>;
  if (state && state.data && state.data.optimizationFailed) return <div className={classes.progressHolder}>
    <div className={classes.progressHolderTop}>
      <ReportProblemTwoToneIcon color="primary" sx={{fontSize: 60}}/>
      <Typography variant="h5" className={classes.loadingTypography}>
      {state.data.optimizationFailureReason}
      </Typography>
    </div>
  </div>
    // if (state && state.data && state.data.errorMessage) return <div>{state.data.errorMessage}</div>
    if (state && state.data && state.data.errorMessage) return <div className={classes.progressHolder}>
    <div className={classes.progressHolderTop}>
      <ReportProblemTwoToneIcon color="primary" sx={{fontSize: 60}}/>
      <Typography variant="h5" className={classes.loadingTypography}>
        {state.data.errorMessage}
      </Typography>
    </div>
  </div>

  const getCurrentKpis = (eqInf: any) => {
    const newCols = prepColumns({
      cols: eqInf.cols,
      materials: eqInf.reco.materials,
      columns: eqInf.mapd,
      columnmap: eqInf.columns,
    });

    const _mats: { [key: string]: any } = {};

    for (let mat of newCols) {
      _mats[mat.material.material_num] = mat;
    }

    const mats = Object.values(_mats).map((v: Bin) => v.material);

    let totalVolume = 0;
    let minimumCover = Number.MAX_SAFE_INTEGER;
    let totalCapacity = 0;
    let avg_visit_period = 0;
    let grlc = 0;
    let rev = 0;
    let seen: string[] = [];

    let seenCounts: { [key: string]: number } = {};

    for (let mat of mats) {
      if (!mat.column_count) mat.column_count = 1;
      else mat.column_count++;
    }

    for (let mat of mats) {
      totalVolume += mat.eaches;
      totalCapacity += mat.column_count! * mat.capacity;
      let cover = (mat.column_count! * mat.capacity) / mat.eaches;
      if (cover < minimumCover && cover > 0 && cover !== Infinity && !isNaN(cover)) {
        minimumCover = cover;
      }
      if (mat.price && mat.cogs && !seen.includes(mat.material_num)) {
        grlc += mat.eaches * (mat.price - mat.cogs);
        rev += mat.eaches * mat.price;
        seen.push(mat.material_num);
      }

      avg_visit_period = mat.avg_visit_period!;
    }

    let out = {
      days_cover: minimumCover,
      eaches: totalVolume,
      flavor_count: mats.length,
      source: "Current",
      grlc,
      rev,
      efr: ((totalVolume * minimumCover) / totalCapacity) * 100,
      avg: avg_visit_period,
    };

    return out;
  };

  const onTheFlyMatMap = (state: any) => {
    const newCols = prepColumns({
      cols: state.data.cols,
      applyRecommended: state.applyRecommendation,
      recommended: state.data.mapd,
      replacing: state.toReplace,
      selected: selected,
      replaced: state.replaced,
      replacePtr: state.replacePtr,
      materials: state.data.reco.materials,
      columns: state.data.cmap,
      columnmap: state.data.columns,
    });

    const _mats: { [key: string]: any } = {};

    for (let mat of newCols) {
      _mats[mat.material.material_num] = mat;
    }

    const mats = Object.values(_mats).map((v: Bin) => v.material);

    let totalVolume = 0;
    let minimumCover = Number.MAX_SAFE_INTEGER;
    let totalCapacity = 0;
    let avg_visit_period = 0;
    let grlc = 0;
    let rev = 0;
    let seen: string[] = [];
    for (let mat of mats) {
      totalVolume += mat.eaches;
      totalCapacity += mat.column_count! * mat.capacity;
      let cover = (mat.column_count! * mat.capacity) / mat.eaches;
      if (cover < minimumCover && cover > 0 && cover !== Infinity && !isNaN(cover)) {
        minimumCover = cover;
      }

      if (mat.price && mat.cogs && !seen.includes(mat.material_num)) {
        grlc += mat.eaches * (mat.price - mat.cogs);
        rev += mat.eaches * mat.price;
        seen.push(mat.material_num);
      }

      avg_visit_period = mat.avg_visit_period!;
    }
if(minimumCover===Number.MAX_SAFE_INTEGER){
  minimumCover =0.00;
}
    let out = {
      days_cover: minimumCover,
      eaches: totalVolume,
      flavor_count: mats.length,
      source: "Recommended",
      grlc,
      rev,
      efr: ((totalVolume * minimumCover) / totalCapacity) * 100,
      //avg: avg_visit_period,
    };
    //console.log(out);   console.log("#####");  console.log(state.data.kpis[1]);
    setState({
      ...state,
      data: {
        ...state.data,
       // kpis: [out],
       kpis: [out, state.data.kpis[1]],
      },
    });
  };

  const highlightClick = (torep: any[], newMat: any) => {
    let nm = typeof newMat === "string" ? { material_num: newMat } : newMat;
    const attemptLook = async () => {
      let found = Object.values(state.data.mapd).find((v: any) => v?.material_num === nm?.material_num);

      if (found) return found;

      return await AXIOS_INSTANCE({
        method: "POST",
        params: {
          clientId: 100,
          salesOrg: salesOrg,
        },
        data: {
          customerNum: custState,
          newFlavors,
          maxFlavors,
          newMat,
        },
        url: `${BASE_URL}/api/recommendation/search`,
      }).then((v) => v.data);
    };

    attemptLook().then((_found: any) => {
      let foundMat: any = {};

      if (Array.isArray(_found) && _found.length > 0) {
        foundMat = _found[0];
      } else if (Array.isArray(_found) && _found.length === 0) {
        foundMat = nm;
      } else if (!!_found) {
        foundMat = _found;
      } else {
        foundMat = nm;
      }

if(foundMat.capacity===1){ setIsDefaultQuantity(true);}
      let replTmp: any = [];

      for (let repl of torep) {
        let column_num = repl.column_num;

        let found: any = state.data.mapd.find((v: any) => v.column_num.localeCompare(column_num) === 0);

        replTmp.push({
          ...found,
          material: {
            ...found.material,
            material_num: foundMat.material_num,
            capacity: foundMat.capacity,
            price: foundMat.price,
            description: foundMat.description,
            eaches: foundMat.eaches,
          },
          swapped:true,
        });
      }

      onTheFlyMatMap({
        ...state,
        toReplace: [],
        replaced: [...state.replaced, ...replTmp],
        bankedReplaced: [
          ...state.bankedReplaced,
          ...replTmp.map((v: any) => ({
            data: v,
            machine: custState,
          })),
        ],
      });
    });
  };

  const swapSelected = (a: any, b: any) => {
    // if (toReplace.length < 2) return;
    //setReqStatus(LoadingStatus.Initial);
    // recalculateKPIs({
    //   ...state,
    //   toReplace: [],
    //   replacePtr: state.replacePtr + 2,
    //   replaced: [
    //     ...state.replaced,
    //     [
    //       {
    //         prev: a,
    //         curr: {
    //           ...b,
    //           column_num: a.column_num,
    //           replaced: true,
    //         },
    //         swapped: true,
    //       },
    //       {
    //         prev: b,
    //         curr: {
    //           ...a,
    //           column_num: b.column_num,
    //           replaced: true,
    //         },
    //         swapped: true,
    //       },
    //     ],
    //   ],
    // });
    // prepSumMatLine(true);
  };

  const changeCapacity = (newCol: any, capacity: number,updateMat:any) => {
    let toRepl: Material[] = [];

    let preppedColumns = prepColumns({
      cols: state.data.cols,
      applyRecommended: state.applyRecommendation,
      recommended: state.data.mapd,
      replacing: state.toReplace,
      selected: selected,
      replaced: state.replaced,
      replacePtr: state.replacePtr,
      materials: state.data.reco.materials,
      columns: state.data.cmap,
      columnmap: state.data.columns,
    });

    for (let mat of preppedColumns) {
      if (mat.column_num === newCol.column_num) {
       if(updateMat) {
          toRepl.push({
            ...mat,
            material: {
              ...updateMat.material
            },
          });
        }
        else{
          toRepl.push({
            ...mat,
            material: {
              ...mat.material,
              capacity,
            },
          });
        }
      }
    }

    onTheFlyMatMap({
      ...state,
      replaced: [...state.replaced, ...toRepl],
      bankedReplaced: [
        ...state.bankedReplaced,
        ...toRepl.map((v) => ({
          machine: custState,
          data: v,
        })),
      ],
    });
  };


// Check any error in Network API Response the restuen to the failure page
  if(showCritFail){
    return(
      <CriticalFailure title='Recommendation - ERROR'>
          <Typography >Failed to generate Space2Sales Recommendation.</Typography>
      </CriticalFailure>
    )
  } 
   if (!state.isLoaded) {
    return (
      <div className={classes.progressHolder}>
        
        <div className={classes.progressHolderTop}>
          <ThinkingLogo />
          <Typography variant="h5" className={classes.loadingTypography}>
            Preparing a new recommendation for {custState}.
          </Typography>
          <Typography variant="h6" className={classes.loadingTypography}>
            Please be patient.
          </Typography>
          <CircularProgress color="primary" />
        </div>
      </div>
    );
  } 

  const cusInfo = state.data.info;
  const location = (cusInfo.building || "") + " " + (cusInfo.room || "")+ " " + (cusInfo.floor || "");

  const wrapper = (children: any) =>
    props.fullpage ? (
      <ResponsiveDrawer
        title={`Reconfiguration for ${cusInfo.sales_office}: ${cusInfo.customer_num} ${cusInfo.name1} [${cusInfo.name3}]`}
      >
        {children}
      </ResponsiveDrawer>
    ) : (
      <div>{children}</div>
    );

  const canSetStatus = (newStatus: string) => {
    let curStatus: string = ("" as string).toUpperCase();
    if (requestNum) {
      curStatus = ((state.data?.newRequest?.request?.status || requestStatus || "") as string).toUpperCase();
    }

    if (!curStatus) return true;
    if (curStatus === "VP_DRAFT" && newStatus === "VP_DRAFT") return true;
    newStatus = newStatus.toUpperCase();
    const REQ_STATUS_ORDER: { [Status: string]: number } = {
      UNSAVED: -99,
      VP_REQUST: 1,
      VP_DRAFT: 1,
      VP_AS_IS: 2,
      VP_QUEUE: 2,
      VP_ACCEPT: 3,
      VP_REJECT: 3,
      VP_SUBMIT: 4,
    };
    let curInt: number = REQ_STATUS_ORDER[curStatus] || 99;
    let newInt: number = REQ_STATUS_ORDER[newStatus] || 99;
    return curInt < newInt;
  };

  const saveDraft = async (status: string) => {
    setBtnActive(true)
    let curStatus = reqStatus;
    curStatus[status] = LoadingStatus.Loading;
    setReqStatus(curStatus);
    let recNo: number = requestNum || 0;
    if (status === "VP_ACCEPT" && requestStatus !== "VP_QUEUE") {
      recNo = (await saveDraft("VP_QUEUE")) || 0;
    }
    if (status === "VP_ACCEPT") {
      let r = await approveRequest(salesOrg, recNo).then(res=>{
        if(res&&res.status){
          setDialogMessage({
            code: res.status,
            message: res.data&&res.data?res.data?.message:'',
          });
          if(!res.data.sapTicketNo){
                setRequestNum(0);
          }
        }else{
          setDialogMessage({
            code: 500,
            message: "Internal Server Error : Please retry later",
          });
        }
        
        setConfirmDialog(true);
        let curStatus = reqStatus;
        curStatus[status] = LoadingStatus.Initial;
        setState((prevState:any) => ({
          ...prevState,
          req: {
            ...prevState.req,
            requests: [
              {
                ...prevState.req.requests[0],
                requestStatus: status ,
                sapRequestNumber:res.data&&res.data?res.data?.sapTicketNo:''

              },
              ...prevState.req.requests.slice(1) 
            ]
          }
        }));
        setReqStatus(curStatus);
        setBtnActive(false)
      }).catch(error=>{
        setBtnActive(false)
      })
     

      return;
    }
    if (recNo < 1) {
      let v = await createRequest(salesOrg, custState);
      if (v && v.status === 200) {
        recNo = v.data.newRequest.request.requestNum;
        setState({
          ...state,
          req: {
            ...state.req, 
            requests:[v.data.newRequest.request]
          },
        });
        setRequestNum(recNo);
        setBtnActive(false)
        setReqStatus(v.data.newRequest.request.requestStatus);
      } else {

        let curStatus = reqStatus;
        curStatus[status] = LoadingStatus.Error;
        setReqStatus(curStatus);
        setBtnActive(false)
        setTimeout(() => {
          let curStatus = reqStatus;
          curStatus[status] = LoadingStatus.Initial;
          setReqStatus(curStatus);
        }, 2000);
      
        return;
      }
    }

    if (recNo >= 1) {
      let prepRecommendationCurrent = prepColumns(
        {
          cols: state.data.cols,
          recommended: state.data.mapd,
          applyRecommended: state.applyRecommendation,
          replaced: state.replaced,
          columns: state.data.cmap,
          columnmap: state.data.columns,
          materials: state.data.reco.materials,
        },
        true
      );

      let prepCurrentLayout = prepColumns(
        {
          cols: state.data.cols,
          recommended: state.data.mapd,
          applyRecommended: false,
          replaced: [],
          columns: state.data.cmap,
          columnmap: state.data.columns,
          materials: state.data.reco.materials,
        },
        true
      );

      let opti = prepRecommendationCurrent.map((rec: any) => {
        let reco = {
          configType: "O",
          columnNum: rec.column_num,
          materialNum: rec.material.material_num,
          columnCapacity: rec.material.capacity,
          avgEaches: rec.material.eaches || 0,
          avgNetwr: rec.material.eaches * rec.material.price || 0,
          avgCogs: rec.material.cogs || 0,
          cogs: rec.material.cogs || 0,
          vendPrice: rec.material.price || 0.0,
          avgGp: rec.material.avg_gp || 0,
          blocked: false,
          avg_visit_period: rec.material.avg_visit_period,
        };

        return reco;
      });

      let repl = (status === "VP_AS_IS" ? prepCurrentLayout : prepRecommendationCurrent).map((pred: any) => {
        pred = {
          configType: "R",
          columnNum: pred.column_num,
          materialNum: pred.material.material_num,
          columnCapacity: pred.material.capacity,
          avgEaches: pred.material.eaches || 0,
          avgNetwr: pred.material.eaches * pred.material.price || 0,
          avgCogs: pred.material.cogs || 0,
          cogs: pred.material.cogs || 0,
          vendPrice: pred.material.price || 0.0,
          avgGp: pred.material.avg_gp || 0,
          blocked: false,
        };

        return pred;
      });

      let curr = prepCurrentLayout.map((pred: any) => {
        pred = {
          configType: "C",
          columnNum: pred.column_num,
          materialNum: pred.material.material_num,
          columnCapacity: pred.material.capacity,
          avgEaches: pred.material.eaches || 0,
          avgNetwr: pred.material.eaches * pred.material.price || 0,
          cogs: pred.material.cogs || 0.0,
          avgCogs: pred.material.cogs || 0,
          vendPrice: pred.material.price || 0.0,
          avgGp: pred.material.avg_gp || 0,
          blocked: false,
        };

        return pred;
      });
      await Promise.all([
        saveRequest(salesOrg, {
          request: {
            customerNum: custState,
            equipmentNum: cusInfo.equipment_num,
            requestStatus: status,
            optimizationType: "",
            optimizationPackMethod: "",
            requestNum: recNo,
            txReqReconfigCol: opti.concat(repl).concat(curr),
            txReqReconfigKpi: state.data.kpis
          },
        })
          .then((v) => {
            if (v.status === 200) {
              let curStatus = reqStatus;
              curStatus[status] = LoadingStatus.Success;
              setReqStatus(curStatus);
              setRequestStatus(status);
              setBtnActive(false)
              setRequestNum(recNo);
              setState((prevState:any) => ({
                ...prevState,
                req: {
                  ...prevState.req,
                  requests: [
                    {
                      ...prevState.req.requests[0],
                      requestStatus: status 
                    },
                    ...prevState.req.requests.slice(1) 
                  ]
                }
              }));
            }
          })
          .catch((_) => {
            let curStatus = reqStatus;
            curStatus[status] = LoadingStatus.Error;
            setReqStatus(curStatus);
            setBtnActive(false)
          })
          .finally(() => {
            setTimeout(() => {
              let curStatus = reqStatus;
              curStatus[status] = LoadingStatus.Initial;
              setReqStatus(curStatus);
          
            }, 2000);
          }),
      ]);
    }
    return recNo;
  };

  prepSumMatLine();

  let options: any = [];

  if (state.strategic && state.strategic.length > 0) {
    options = options.concat(
      state.strategic.map((s: any) => ({
        data: `${s.material_num_short} - ${s.description}`,
        material_num: s.material_num,
        source: "Strategic",
      }))
    );
  }
  if (state.aml && state.aml.length > 0) {
    options = options.concat(
      state.aml.map((s: any) => ({
        data: `${s.materialNumShort} - ${s.description}`,
        description: s.description,
        material_num: s.materialNum,
        authMaterialListId:s.authMaterialListId,
        source: `AML (${state?.aml?.length} / ${state?.aml?.[0]?.authMaterialListId} / ${state?.aml?.[0]?.authMaterialExclListId})`,
        tooltip: `AML(count / Incl Mat List ID / Excl Mat List ID)`,
      }))
    );
  }

const processedOptions = options.map((o:any, index:any) => ({
  ...o,
  _uid: index // unique always
}));
  return wrapper(
    <div className={classes.root}>
   
       {recAllowed ? 
       (<div className={classes.progressHolder}>
        <div className={classes.progressHolderTop}>
          <ReportProblemTwoToneIcon color="primary" sx={{fontSize: 60}}/>
          <Typography variant="h5" className={classes.loadingTypography}>
            No Recommendation is available for {custState}.
          </Typography>
        </div>
      </div>) : 
       <>
       <Grid container spacing={0} className={classes.gridMarginTop}>
        <Grid item md={4} lg={6} className={classes.gridSpaceable}>
          <Card>
            <CardContent className={classes.cardContent}>
              <Grid container>
                <Grid item xs={2}>
                  <TextField
                    fullWidth={true}
                    label="Model"
                    value={cusInfo.model}
                    defaultValue={cusInfo.model}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth={true}
                    label="Asset #"
                    value={cusInfo.asset_num}
                    defaultValue={cusInfo.asset_num}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth={true}
                    label="Equip #"
                    value={removeLeadingZeros(cusInfo.equipment_num)}
                    defaultValue={removeLeadingZeros(cusInfo.equipment_num)}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth={true}
                    label="Graphic"
                    value={determineConfig(state.codes, "GRAPHICS", cusInfo.graphic)}
                    defaultValue={determineConfig(state.codes, "GRAPHICS", cusInfo.graphic)}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item>
                <TextField
                  fullWidth={true}
                  label="Equipment Location"
                  value={location}
                  defaultValue={location}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item md={8} lg={6} className={classes.gridSpaceable}>
          <CardKPI kpis={state.data.kpis} />
        </Grid>
      </Grid>
      <Grid container>
        {!!requestNum && (
          <Grid item xs={6}>
            <RequestTiny data={state.req}></RequestTiny>
          </Grid>
        )}
        <Grid item>
          <FormGroup row>
            {!!requestNum && (
              <>
                <Tooltip title="View all customer invoices.">
                  <Button
                    className={classes.topFormGroup}
                    color="primary"
                    variant="contained"
                    key={`EquipmentUnitIndiv-InvoicePipbutton`}
                    onClick={() => setDisplayInvoicePip(true)}
                    size="small"
                  >
                    <ReceiptIcon />
                    View Invoices
                  </Button>
                </Tooltip>
                <Tooltip title="Open EFR History page.">
                  <Button
                    className={classes.topFormGroup}
                    color="primary"
                    variant="contained"
                    disabled={!(EFRHistoryData.length > 0)}
                    key={`EquipmentUnitIndiv-EFR-History`}
                    onClick={() => setState({ ...state, displayEFRHistory: true })}
                    size="small"
                  >
                    <ReceiptIcon />
                    View EFR History
                  </Button>
                </Tooltip>
                {state.bankedRecos?.length > 0 && (
                  <>
                    <Tooltip title="Open bank overview page.">
                      <Button
                        className={classes.topFormGroup}
                        color="primary"
                        variant="contained"
                        key={`EquipmentUnitIndiv-BankOverview`}
                        onClick={() => setState({ ...state, displayBankOverview: true })}
                        size="small"
                      >
                        <ReceiptIcon />
                        View Bank
                      </Button>
                    </Tooltip>
                    <Tooltip title="Change to next customer in this bank. This should only take a second.">
                      <Button
                        variant="contained"
                        onClick={() => {
                          let indexOfCurrent = state.bankedRecos?.findIndex(
                            (v: any) => v.info?.customer_num === custState
                          );

                          if (indexOfCurrent === state.bankedRecos?.length - 1) {
                            setCustState(state.bankedRecos[0]?.info?.customer_num);
                          } else {
                            setCustState(state.bankedRecos[indexOfCurrent + 1]?.info?.customer_num);
                          }

                          setState({
                            ...state,
                            nextCustomer: true,
                          });
                        }}
                      >
                        Next Customer
                      </Button>
                    </Tooltip>
                  </>
                )}
              </>
            )}
          </FormGroup>
          {!requestNum && (
            <FormGroup row>
              <FormControlLabel
                className={classes.topFormGroup}
                control={
                  <Checkbox checked={showCurrent} onChange={() => setShowCurrent(!showCurrent)} name="checkedShowRec" />
                }
                label="Show Current"
              />
              <FormControlLabel
                className={classes.topFormGroup}
                control={
                  <Checkbox
                    checked={newFlavors}
                    onChange={() => {
                      setNewFlavors(!newFlavors);
                      setMaxFlavors(!maxFlavors);
                      setState({
                        ...state,
                        isLoaded: false,
                      });
                    }}
                    name="checkedNewFlavors"
                  />
                }
                label="New Flavors"
              />
              <Tooltip title={`Min Flavors: ${state.data.curr[0].min_flavors}
              Max Flavors: ${state.data.curr[0].max_flavors}`}>
                <FormControlLabel
                  className={classes.topFormGroup}
                  control={
                    <Checkbox
                      checked={maxFlavors}
                      onChange={() => {
                        setMaxFlavors(!maxFlavors);
                        setNewFlavors(!newFlavors);
                        setState({
                          ...state,
                          isLoaded: false,
                        });
                      }}
                      name="checkedMaxFlavors"
                    />
                  }
                  label="Max Flavors"
                />
              </Tooltip>

              {state.data.curr.length > 12 && (
                <FormControlLabel
                  className={classes.topFormGroup}
                  control={
                    <Checkbox
                      checked={state.useBrandflowOpt}
                      onChange={() => {
                        setState({
                          ...state,
                          useBrandflowOpt: !state.useBrandflowOpt,
                          isLoaded: false,
                        });
                      }}
                      name="checkedForceBrandflow"
                    />
                  }
                  label="Enforce Brandflow"
                />
              )}
              <Tooltip title="Manually override column capacities.">
                <FormControlLabel
                  className={classes.topFormGroup}
                  label="Edit Capacity"
                  control={
                    <Switch
                      checked={state.editCapacity}
                      onClick={() => {
                        setState({
                          ...state,
                          editCapacity: !state.editCapacity,
                        });
                      }}
                    />
                  }
                />
              </Tooltip>
              <Tooltip title="View open tickets for the customer if applicable.">
                <Button
                  className={classes.topFormGroup}
                  color="primary"
                  variant="contained"
                  key={`EquipmentUnitIndiv-reconfigbutton`}
                  onClick={() => setDisplayPip(true)}
                  size="small"
                  disabled={!requestNum}
                >
                  <ConfirmationNumberIcon />
                  View Ticket
                </Button>
              </Tooltip>
              <Tooltip title="View all customer invoices.">
                <Button
                  className={classes.topFormGroup}
                  color="primary"
                  variant="contained"
                  key={`EquipmentUnitIndiv-InvoicePipbutton`}
                  onClick={() => setDisplayInvoicePip(true)}
                  size="small"
                >
                  <ReceiptIcon />
                  View Invoices
                </Button>
              </Tooltip>
              <Tooltip title="Open EFR History page.">
                <Button
                  className={classes.topFormGroup}
                  color="primary"
                  variant="contained"
                  disabled={!(EFRHistoryData?.length > 0)}
                  key={`EquipmentUnitIndiv-EFR-History`}
                  onClick={() => setState({ ...state, displayEFRHistory: true })}
                  size="small"
                >
                  <ReceiptIcon />
                  View EFR History
                </Button>
              </Tooltip>
              {state.bankedRecos && state.bankedRecos.length >= 2 && (
                <div>
                  <Tooltip title="Open bank overview page.">
                    <Button
                      className={classes.topFormGroup}
                      color="primary"
                      variant="contained"
                      key={`EquipmentUnitIndiv-BankOverview`}
                      onClick={() => setState({ ...state, displayBankOverview: true })}
                      size="small"
                    >
                      <ReceiptIcon />
                      View Bank
                    </Button>
                  </Tooltip>
                  <Tooltip title="Change to next customer in this bank. This should only take a second.">
                    <Button
                      variant="contained"
                      onClick={() => {
                        let indexOfCurrent = state.bankedRecos.findIndex(
                          (v: any) =>{
                            if(v.info){
                              return v.info.customer_num === custState;
                            }
                          });
                        let customer_num: string = "";

                        if (indexOfCurrent === state.bankedRecos.length - 1) {
                         
                          if(state.bankedRecos[0].info){
                            customer_num = state.bankedRecos[0].info.customer_num;
                            setCustState(customer_num);
                          }
                        } else {
                          if(state.bankedRecos[indexOfCurrent + 1].info){
                            customer_num = state.bankedRecos[indexOfCurrent + 1].info.customer_num;
                            setCustState(customer_num);
                          }
                        }

                        setState({
                          ...state,
                          nextCustomer: true,
                          // This performs loading materials back into replaced when we switch customers.
                          replaced: state.bankedReplaced
                            .filter((v: any) => v.machine === customer_num)
                            .map((v: any) => v.data),
                        });
                      }}
                    >
                      Next Customer
                    </Button>
                  </Tooltip>
                </div>
              )}
            </FormGroup>
          )}
        </Grid>
      </Grid>
      <Visualizers />
      {(!requestNum || (requestNum && requestStatus==='VP_DRAFT') )&& (
        <Grid container className={classes.buttonAllGroup}>
          <Grid item xs={12} lg={6}>
            <Autocomplete
              id="replace-selected"
              options={processedOptions.sort((a: any, b: any) => a.source.localeCompare(b.source) > 0)}
              getOptionLabel={(option: any) => `${option.data}`}
              groupBy={(option) => option.source}
               renderGroup={(params) => {
    const option = processedOptions.find(
      (o:any) => o.source === params.group
    );

    return (
      <li key={params.key}>
        <Tooltip title={option?.tooltip || ""} arrow>
          <div
            style={{
              fontWeight: 600,
              padding: "8px 16px",
              cursor: "help",
            }}
          >
            {params.group}
          </div>
        </Tooltip>
        <ul style={{ padding: 0 }}>{params.children}</ul>
      </li>
    );
  }}
              isOptionEqualToValue={(o, v) => o._uid === v._uid}
              onChange={(_, newMat) => {
                if (!newMat) return;
                highlightClick(state.toReplace, newMat);
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  let newMat = (event.target as any).value;
                  if (!newMat) return;
                  let found = processedOptions.find((v: any) => v.data === newMat);
                  if (!found) return;
                  highlightClick(state.toReplace, found);
                }
              }}
              renderOption={(props, option) => (
          <span
            {...props}
           
          key={option._uid}>
            {option.data}
          </span>
        )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Replace Material"
                  helperText="Click material or press the enter key once selected."
                />
              )}
            />
          </Grid>
          <Grid item xs={6} lg={3}>
            {checkForRole("100", salesOrg, "vp_create_ticket") && (requestStatus!=='I' && requestStatus!=='M') && (
              <div className={classes.slightButtonPadding}>
                <CircularLoadButton
                  title="No Change"
                  disabled={!canSetStatus("VP_AS_IS") || btnActive}
                  status={reqStatus.VP_AS_IS}
                  loadFn={() => saveDraft("VP_AS_IS")}
                />
                {/* @Lijo suggested to hide the DRAFT button on Tom's recommendation as temporary fix until draft functionality changes are done*/}
                 <CircularLoadButton
                  title="Draft"
                  icon={<SaveIcon />}
                  disabled={!canSetStatus("VP_DRAFT") || btnActive}
                  status={reqStatus.VP_DRAFT}
                  loadFn={() => saveDraft("VP_DRAFT")}
                /> 
                <CircularLoadButton
                  title="Queue"
                  icon={<PlaylistAddCheckIcon />}
                  disabled={!canSetStatus("VP_QUEUE")|| btnActive}
                  status={reqStatus.VP_QUEUE}
                  loadFn={() => saveDraft("VP_QUEUE")}
                />
              </div>
            )}
            {checkForRole("100", salesOrg, "vp_approve_ticket") && (requestStatus!=='I' && requestStatus!=='M') && (
              <CircularLoadButton
                title="Accept"
                disabled={!canSetStatus("VP_ACCEPT") || btnActive}
                status={reqStatus.VP_ACCEPT}
                loadFn={() => saveDraft("VP_ACCEPT")}
              />
            )}
          </Grid>
          <Grid item xs={6} lg={3}>
            {state.applyRecommendation && (
              <Button
                variant="contained"
                size="large"
                color="primary"
                className={classes.buttongroup}
                onClick={() => {
                  //setReqStatus(LoadingStatus.Initial);

                  let x = state.bankedApplyRecommendation;
                  let idx = x.findIndex((v: any) => v.machine === custState);

                  if (idx >= 0) {
                    x.splice(idx, 1);
                  }

                  onTheFlyMatMap({
                    ...state,
                    toReplace: [],
                    applyRecommendation: false,
                    replacePtr: 0,
                    replaced: [],
                    bankedReplaced: state.bankedReplaced.filter((v: any) => v.machine !== custState),
                    bankedApplyRecommendation: [
                      ...x,
                      {
                        machine: custState,
                        state: false,
                      },
                    ],
                  });
                }}
              >
                Reset to Current
              </Button>
            )}
            {!state.applyRecommendation && (
              <Button
                variant="contained"
                size="large"
                color="primary"
                className={classes.buttongroup}
                onClick={() => {
                  //setReqStatus(LoadingStatus.Initial);

                  let x = state.bankedApplyRecommendation;
                  let idx = x.findIndex((v: any) => v.machine === custState);

                  if (idx >= 0) {
                    x.splice(idx, 1);
                  }

                  onTheFlyMatMap({
                    ...state,
                    applyRecommendation: true,
                    toReplace: [],
                    replacePtr: 0,
                    replaced: [],
                    bankedApplyRecommendation: [
                      ...x,
                      {
                        machine: custState,
                        state: true,
                      },
                    ],
                  });
                }}
              >
                Reset to Recommendation
              </Button>
            )}
          </Grid>
        </Grid>
      )}

      <MaterialsComponents />
      <Grid container spacing={1} className={classes.settlementGrid}>
        <Grid item xs={12} lg={6}>
          {state.data.callouts && state.data.callouts.length >= 0 && (
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                <Typography>Callouts ({state.data.callouts.length})</Typography>
                {!!state.settlements && Object.keys(state.settlements).length < 2 && (
                  <Chip
                    className={classes.strategicChip}
                    label="Less than 2 Settlements"
                    size="small"
                    color="primary"
                  ></Chip>
                )}
                {state.strategic && state.strategic.length > 0 && (
                  <Tooltip title={`Check AML (${state.strategic.map((s: any) => s.material_num_short).join(", ")})`}>
                    <Chip className={classes.strategicChip} label="Strategic" size="small" color="primary"></Chip>
                  </Tooltip>
                )}
              </AccordionSummary>
              <AccordionDetails>
                <div className={classes.alert}>
                  {!!state.settlements && Object.keys(state.settlements).length < 2 && (
                    <Alert severity="warning">Warning: Customer has less than two settlements</Alert>
                  )}
                  {state.data.callouts.map((v: any) => (
                    <Alert severity="warning">
                      Warning: {v.type} for {v.material_num} ({v.materialDesc}).
                    </Alert>
                  ))}
                </div>
              </AccordionDetails>
            </Accordion>
          )}
        </Grid>
        <Grid xs={12} lg={6}>
          {state.data.suggestions && state.data.suggestions.length >= 0 && (
            <Accordion className={classes.calloutsMarginTop}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Suggestions ({state.data.suggestions.length})</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className={classes.alert}>
                  {state.data.suggestions.map((v: any) => (
                    <Alert
                      severity={v.severity}
                      icon={
                        v.type === "ADD" ? (
                          <AddIcon fontSize="inherit" />
                        ) : v.type === "REMOVE" ? (
                          <RemoveIcon fontSize="inherit" />
                        ) : v.type === "EDIT" ? (
                          <EditIcon fontSize="inherit" />
                        ) : (
                          <InfoIcon fontSize="inherit" />
                        )
                      }
                    >
                      {v.messageShort}
                    </Alert>
                  ))}
                </div>
              </AccordionDetails>
            </Accordion>
          )}
        </Grid>
      </Grid>
      {!requestNum && (
        <Grid container spacing={3} className={classes.settlementGrid}>
          <Grid item xs={10}>
            <div className={classes.slider}>
              <Slider
                value={sliderValue}
                onChange={(event, newValue: any) => {
                  setSliderValue(newValue);
                  setRecoStatus(LoadingStatus.Initial);
                }}
                valueLabelDisplay="on"
                marks={true}
                min={0}
                max={state.settlements && Object.values(state.settlements).length - 1} // Might tweak...
                aria-labelledby="range-slider"
                components={{
                  ValueLabel: (props: any) => {
                    let dt = new Date(Object.keys(state.settlements)[props.value]);
                    return (
                      <Tooltip placement="top" title={dt.toLocaleDateString()}>
                        {props.children}
                      </Tooltip>
                    );
                  },
                }}
                aria-disabled
              />
            </div>
          </Grid>

          <Grid item xs={2}>
            <CircularLoadButton
              tooltip="Note: This range is *inclusive* meaning if the distance is one, two settlements are selected."
              title={`Apply Range (${(sliderValue as any)[1] - (sliderValue as any)[0] + 1} STLs)`}
              status={recoStatus}
              loadFn={() => {
                setState({
                  ...state,
                  isLoaded: false,
                });
                setRecoStatus(LoadingStatus.Loading);
              }}
            />
          </Grid>
        </Grid>
      )}
      <Paper className={classes.graphExtraPadding}>
        <Grid container spacing={4}>
          <Grid item xs={12} lg={12} xl={!requestNum ? 6 : 12}>
            <SettlementWrapper />
          </Grid>
          {!requestNum && (
            <Grid item xs={12} lg={12} xl={6}>
                {(state.data.info.convenience_percentage ||state.data.info.fsv_percentage ) && ( <Typography variant="h5" className={classes.centerTitle}>
               Trade and Sub trade channel Configuration details
               <Typography variant="h6" className={classes.centerTitle}>Trade Channel : {state.data.info.trade_channel_name},
               Sub Trade Channel: {state.data.info.sub_trade_channel}
               </Typography>
               <Typography variant="h6" className={classes.centerTitle}>FSV : {state.data.info.fsv_percentage}%
               Convenience: {state.data.info.convenience_percentage}%
               </Typography>
        </Typography>)}
              <VolumePredictions />
            </Grid>
          )}
        </Grid>
      </Paper>
      {!requestNum && (
        <Grid container spacing={1}>
          <Grid item lg={12} xl={6}>
            <CardLocalFavorites
              customerNum={custState || ""}
              lfCols={5}
              lfRows={4}
              curMaterialNums={(sumLines || [])
                .filter((sl: any) => sl.change.action !== "ADD")
                .map((sl: any) => sl.materialNum)}
              newMaterialNums={(sumLines || [])
                .filter((sl: any) => sl.change.action !== "REMOVE")
                .map((sl: any) => sl.materialNum)}
            />
          </Grid>
          <Grid item lg={12} xl={6}>
            <CardTradeChannelView customerNum={custState || ""} />
          </Grid>
        </Grid>
      )}
      <PageInPage
        onClose={() => {
          setDisplayPip(false);
        }}
        title={`Request ${requestNum}`}
        isOpen={displayPip}
        content={
          <VendPrimeRequest
            requestNum={requestNum}
            onClose={() => {
              setDisplayPip(false);
            }}
          />
        }
      />
      <PageInPage
        onClose={() => setState({ ...state, displayBankOverview: false })}
        title={"Bank Overview"}
        isOpen={state.displayBankOverview}
        content={
          <BankOverview
            customer_num={custState}
            setRecoState={(newState: any, replaced: any) => {
              const changedInThisMachine = replaced.filter((v: any) => v.machine === custState).map((v: any) => v.data);
              setState({
                ...state,
                replaced: [...state.replaced, ...changedInThisMachine],
                bankedRecos: newState,
                bankedReplaced: [...state.bankedReplaced, ...replaced],
              });
            }}
            bankedRecommendations={state.bankedRecos}
            bankedReplaced={state.bankedReplaced}
            bankedApplyRecommendation={state.bankedApplyRecommendation}
            replaceMaterialSelectorOpts={options}
          />
        }
      />
      <PageInPage
        onClose={() => {
          setDisplayInvoicePip(false);
        }}
        title={`Customer ${custState} Invoices`}
        isOpen={displayInvoicePip}
        content={<SettlementUnit CustomerNum={custState} />}
      />
      <PageInPage
        onClose={() => setState({ ...state, displayEFRHistory: false })}
        title={"EFR History"}
        isOpen={state.displayEFRHistory}
        content={
          <EFRHistory
            title={`${cusInfo.sales_office}: ${cusInfo.customer_num} ${cusInfo.name1}`}
            EFRData={EFRHistoryData}
            settlement={settlementData}
          />
        }
      />
      <Dialog
        open={confirmDialog}
        onClose={() => {
          setConfirmDialog(false);
        }}
      >
        <DialogTitle>{(dialogMessage?.code || 500) > 400 ? "Error" : "Success"}</DialogTitle>
        <DialogContent>
          <DialogContentText>{(dialogMessage?.message || "").toString()}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setConfirmDialog(false);
            }}
            color="primary"
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isBankError}
        onClose={() => {
          setIsBankError(false);
        }}
      >
        <DialogTitle>Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>{errorMsg}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIsBankError(false);
            }}
            color="primary"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isDefaultQuantity}
        onClose={() => {
          setIsDefaultQuantity(false);
        }}
      >
        <DialogTitle>Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>Material Max fill has been defaulted, Please verify missing Pack Type, Pack Size for Model Capacity configuration AND/OR Vend Price is $0.00 and will impact KPI's unless updated with proper price.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIsDefaultQuantity(false);
            }}
            color="primary"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isMinFlavourLogic}
        onClose={() => {
          setIsMinFlavourLogic(false);
        }}
      >
        <DialogTitle>Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>Not enough sales or machine learnings to maintain minimum flavors : {minFlavourCount}
<br />Comply with channel standards for adding brands to this vendor.
 </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIsMinFlavourLogic(false);
            }}
            color="primary"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isCurrMatNotAML}
        onClose={() => {
          setIsCurrMatNotAML(false);
        }}
      >
        <DialogTitle>Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>{isCurrMatNotAMLMessage} 
 </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIsCurrMatNotAML(false);
            }}
            color="primary"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
       </>
       }
    </div>
  );
}
